import * as React from 'react';

import { plural } from '@cian/utils';

import { INewObject } from '../../types';
import { IconedLink } from '../iconed_link';
import { ConstructionProgress } from './icons/constructionProgress';
import { GalleryVideoIcon } from './icons/video';
import { ReviewsIcon } from './icons/reviews';
import { trackVideosFeatureClick, trackReviewsFeatureClick, trackConstructionProgressFeatureClick } from './trackings';

import * as styles from './index.css';

export interface INewbuildingFeaturesProps {
  newObject: INewObject;
  isABNewbuildingFeaturesExperimentEnabled: boolean;
}

export const NewbuildingFeatures = (props: INewbuildingFeaturesProps) => {
  if (!props.newObject.newbuildingFeatures || !props.isABNewbuildingFeaturesExperimentEnabled) {
    return null;
  }

  const { videosCount = 0, reviewsCount = 0, hasProgressOfConstructions } = props.newObject.newbuildingFeatures;
  const url = props.newObject.fullUrlWithSubdomain || props.newObject.url;

  return (
    <ul className={styles['container']}>
      <li className={styles['item']}>
        <IconedLink
          text="Ход строительства"
          icon={<ConstructionProgress />}
          isDisabled={!url || !hasProgressOfConstructions}
          link={`${url}hod-stroitelstva/`}
          onClick={trackConstructionProgressFeatureClick}
        />
      </li>
      <li className={styles['item']}>
        <IconedLink
          text={`${videosCount} видео`}
          icon={<GalleryVideoIcon />}
          isDisabled={Boolean(!url || videosCount === 0)}
          link={`${url}?open_video=1`}
          onClick={trackVideosFeatureClick}
        />
      </li>
      <li className={styles['item']}>
        <IconedLink
          text={`${reviewsCount} ${plural(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}`}
          icon={<ReviewsIcon />}
          isDisabled={Boolean(!url || reviewsCount === 0)}
          link={`${url}otzyvy`}
          onClick={trackReviewsFeatureClick}
        />
      </li>
    </ul>
  );
};
